import { render, staticRenderFns } from "./CbsObjectCatalog.vue?vue&type=template&id=6c17fb1c&scoped=true"
import script from "./CbsObjectCatalog.vue?vue&type=script&lang=js"
export * from "./CbsObjectCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c17fb1c",
  null
  
)

export default component.exports